import { dialogClose } from "@/modules/MuiDialog"
import DialogTitleBox from "@/modules/MuiDialog/DialogTitleBox"
import { requestOpenMallV2 } from "@/services/open-mall.service"
import { Button, Checkbox, DialogActions, DialogContent, FormControlLabel, Link, Typography } from "@mui/material"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

export default function ConfirmMallOpenDialog({ to, onComplete }: { to?: string; onComplete?: () => void }) {
    const navigate = useNavigate()
    const [termCheck, setTermCheck] = useState(false)
    const [marketingCheck, setMarketingCheck] = useState(false)
    return (
        <>
            <DialogTitleBox title='판매 시작하기' />
            <DialogContent>
                <Typography>판매를 하기 위해서는 판매정책 약관 동의가 필요합니다.</Typography>
                <Link href={'https://terms.flowing.tel/'} target={'_blank'}>약관 보러가기{'>>'}</Link>
                <br />
                <br />
                <Typography>판매를 시작하기 전에, 마케팅 정보 수신 동의 여부를 확인하고자 합니다.</Typography>
                <br />
                <Typography>고객님께서 마케팅 이메일 또는 SMS 수신에 동의하시면, 다양한 혜택과 최신 소식을 가장 먼저 받아보실 수 있습니다.</Typography>
                <Typography>물론, 동의하지 않으셔도 상품 판매에는 아무런 영향이 없습니다.</Typography>
                <br />
                <div className='w-full flex flex-col'>
                    <FormControlLabel
                        sx={{ m: 0, p: 0 }}
                        control={<Checkbox />}
                        label="판매정책 약관에 동의합니다. [필수]"
                        checked={termCheck}
                        onChange={(e, checked) => {
                            setTermCheck(checked)
                        }}
                    />
                    <FormControlLabel
                        sx={{ m: 0, p: 0 }}
                        control={<Checkbox />}
                        label="마케팅 수신 여부에 동의합니다."
                        checked={marketingCheck}
                        onChange={(e, checked) => {
                            setMarketingCheck(checked)
                        }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={!termCheck} variant='contained' onClick={async () => {
                    try {
                        await requestOpenMallV2({
                            smsMarketingConsented: marketingCheck,
                            emailMarketingConsented: marketingCheck
                        })
                        if (!to) {
                            navigate('/switch')
                        }
                        if (!!onComplete) {
                            onComplete()
                        }
                    } catch (error) {
                        toast.error('상점 개설에 실패하였습니다. 잠시 후 다시 시도해주세요.')
                        throw error
                    } finally {
                        dialogClose()
                    }
                }}>판매 시작하기</Button>
                <Button variant='outlined' onClick={() => { dialogClose() }}>나중에 할게요</Button>
            </DialogActions>
        </>
    )
}